export const VIEW_TERM_REPORT = 'view-term-report';
